import { useContext } from 'react';
import { BoardNodesContext } from 'contexts/BoardNodesContext';
import type { BoardNodesContextValue } from 'contexts/BoardNodesContext';

export const useBoardNodesContext = (): BoardNodesContextValue => {
  const context = useContext(BoardNodesContext);
  if (!context) {
    console.warn(
      'useBoardNodesContext must be used within a Spark/Memory Context'
    );
    return {
      selectedNodes: [],
      handleAddToNodeSelection: () => {},
      handleRemoveNodesFromSelection: () => {},
      clearSelection: () => {},
      isBoardNodeCollapsedView: false,
      setIsBoardNodeCollapsedView: () => {},
      setSelectedNodes: () => {},
    };
  }
  return context;
};
